import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ConsoleLayout from './ConsoleLayout';
import ConsoleDashboard from './ConsoleDashboard';
import PowerPointGenerator from './PowerPointGenerator';
import FAQGenerator from './FAQGenerator';
import BattlecardGenerator from './BattlecardGenerator';
import ArchitectureGenerator from './ArchitectureGenerator';
import GameMaker from './GameMaker';
import LMSCourseCreator from './LMSCourseCreator';
import CustomerSalesCallSimulator from './CustomerSalesCallSimulator';
import ContentAnalytics from './ContentAnalytics';
import AgentAnalyticsDashboard from './AgentAnalyticsDashboard';
import CustomerAnalyticsDashboard from './CustomerAnalyticsDashboard';
import AgentFeedbackDashboard from './AgentFeedbackDashboard';
import AgentManager from './AgentManager';
import CustomerManager from './CustomerManager';
import WebhookManager from './WebhookManager';
import UserApiKeyManager from './UserApiKeyManager';
import UserProfile from './UserProfile';
import DocumentationLibrary from './DocumentationLibrary';

const ConsoleWrapper = () => {
  return (
    <ConsoleLayout>
      <Routes>
        {/* Console Dashboard */}
        <Route path="/" element={<ConsoleDashboard />} />
        
        {/* Tools */}
        <Route path="/tools/powerpoint" element={<PowerPointGenerator />} />
        <Route path="/tools/faq" element={<FAQGenerator />} />
        <Route path="/tools/battlecard" element={<BattlecardGenerator />} />
        <Route path="/tools/architecture" element={<ArchitectureGenerator />} />
        <Route path="/tools/game" element={<GameMaker />} />
        <Route path="/tools/lms" element={<LMSCourseCreator />} />
        <Route path="/tools/sales-sim" element={<CustomerSalesCallSimulator />} />
        
        {/* Analytics */}
        <Route path="/analytics/content" element={<ContentAnalytics />} />
        <Route path="/analytics/agents" element={<AgentAnalyticsDashboard />} />
        <Route path="/analytics/customers" element={<CustomerAnalyticsDashboard />} />
        <Route path="/analytics/feedback" element={<AgentFeedbackDashboard />} />
        
        {/* Admin */}
        <Route path="/admin/agents" element={<AgentManager />} />
        <Route path="/admin/customers" element={<CustomerManager />} />
        <Route path="/admin/webhooks" element={<WebhookManager />} />
        <Route path="/admin/api-keys" element={<UserApiKeyManager />} />
        
        {/* Settings */}
        <Route path="/settings" element={<UserProfile />} />
        
        {/* Documentation */}
        <Route path="/documentation" element={<DocumentationLibrary />} />
        
        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConsoleLayout>
  );
};

export default ConsoleWrapper; 